import React from 'react';
import { Link } from 'react-router-dom';

const RefundPolicy = () => {
  return (
    <main className="min-h-screen relative pt-24 pb-24">
      {/* Ambient background glow */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/5 rounded-full blur-[120px] -z-10 pointer-events-none"></div>
      
      <section className="max-w-4xl mx-auto px-margin-mobile md:px-margin-desktop">
        
        {/* Breadcrumbs */}
        <div className="flex items-center space-x-2 text-[12px] text-on-surface-variant mb-12">
          <Link to="/" className="hover:text-primary transition-colors">Home</Link>
          <span>/</span>
          <span className="text-silver-text">Refund Policy</span>
        </div>

        {/* Header */}
        <div className="mb-16">
          <div className="bg-primary/10 text-primary text-[10px] font-bold uppercase tracking-widest px-3 py-1 rounded inline-block mb-6 border border-primary/20">
            Refund Guidelines
          </div>
          <h1 className="font-display-lg text-[48px] md:text-[64px] font-bold text-silver-text mb-4 leading-tight">
            Refund <span className="text-primary">Policy</span>
          </h1>
          <p className="text-[14px] text-on-surface-variant">
            Last Updated: June 4, 2026
          </p>
        </div>

        {/* Content */}
        <div className="space-y-12 text-[15px] text-on-surface-variant leading-relaxed">
          
          {/* Section 1 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">1. Nature of Digital Products</h2>
            <p>
              Because all Expert Advisors, indicator files, and setfiles sold on Algo Forex EA are digital products downloadable immediately upon transaction validation, they cannot be physically returned or recalled. Once a file is downloaded or delivered, the digital asset is permanently in your possession.
            </p>
          </div>

          {/* Section 2 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">2. Support-First Approach</h2>
            <div className="bg-[#1A1B20] border border-primary/20 rounded-xl p-6 mb-6">
              <div className="text-primary text-[12px] font-bold uppercase tracking-widest mb-3">
                Technical Resolution Priority
              </div>
              <p className="text-[14px]">
                Most technical difficulties (EA not opening trades, license errors on MT4/MT5, incorrect chart timeframes, or lack of indicators) are caused by minor terminal configuration mistakes. Before requesting any refund, you agree to coordinate with our technical support team via WhatsApp or Email. We will assist you with proper configuration, setfiles, and terminal troubleshooting.
              </p>
            </div>
          </div>

          {/* Section 3 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">3. Refund Eligibility Criteria</h2>
            <p className="mb-4">
              Refunds are evaluated on a case-by-case basis and are only issued under the following specific circumstances:
            </p>
            <ul className="list-disc pl-5 space-y-3">
              <li><strong className="text-silver-text">Corrupted or Non-Functional Files:</strong> The downloaded file is corrupt, throws fatal compilation errors in a standard MetaTrader terminal, and our technical support team is unable to provide a functional replacement within 3 business days.</li>
              <li><strong className="text-silver-text">Double Purchases:</strong> You accidentally purchased the exact same Expert Advisor twice in a single transaction or sequence. In this case, the duplicate charge will be fully refunded.</li>
              <li><strong className="text-silver-text">Unreleased Pre-Orders:</strong> You purchased a pre-order or custom EA source that has not yet been delivered, and you request cancellation prior to file transmission.</li>
            </ul>
          </div>

          {/* Section 4 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">4. Non-Refundable Situations</h2>
            <p className="mb-4">
              Under no circumstances will refunds be issued for the following reasons:
            </p>
            <ul className="list-disc pl-5 space-y-3">
              <li><strong className="text-silver-text">Market Losses or Drawdown:</strong> Financial losses incurred during live or demo account trading. Market environments are unpredictable, and you assume all risks when deploying an EA on live capital.</li>
              <li><strong className="text-silver-text">Change of Mind:</strong> Deciding you no longer want the EA, changing trading styles, or failing to read requirements (such as platform MT4 vs MT5 compatibility) prior to purchase.</li>
              <li><strong className="text-silver-text">Broker or Server Issues:</strong> Execution errors caused by broker spread expansion, daily swap fees, VPS connection outages, or terminal disconnection.</li>
              <li><strong className="text-silver-text">Evaluation Failures:</strong> Inability to pass prop firm challenges. While some EAs are prop-safe, challenge outcomes are heavily dependent on market timing, lot sizes, and broker rules.</li>
            </ul>
          </div>

          {/* Section 5 */}
          <div>
            <h2 className="text-[20px] font-bold text-silver-text mb-4">5. Refund Request and Contact Procedure</h2>
            <p className="mb-4">
              To file a request for a refund:
            </p>
            <ol className="list-decimal pl-5 space-y-3">
              <li>Email your request to <strong className="text-silver-text">theforexbotshop@gmail.com</strong> or contact us on WhatsApp.</li>
              <li>Include your Order ID, account email, and a detailed description of the issue.</li>
              <li>Provide screenshots or video recordings of the MetaTrader terminal showing the setup and the specific compilation error in the "Journal" or "Experts" logs.</li>
              <li>Allow up to 2-5 business days for our support team to verify the logs and process eligible payouts back to your original payment method.</li>
            </ol>
          </div>

        </div>
      </section>
    </main>
  );
};

export default RefundPolicy;
